import { isEmpty } from 'lodash';

// check if route requires authentication
export const isAuthPage = ({ route }) => !route.meta.hasOwnProperty('forVisitors') || true !== route.meta.forVisitors;

export const isAuth = ({ token }) => !isEmpty(token);

export const authUser = ({ auth }) => auth.user;

export const userAbilities = ({ auth }) => auth.abilities;

export const projectAbilities = ({ auth }) => auth.project_abilities;

export const userSettings = ({ auth }) => auth.settings;

export const messages = ({ messages }) => messages;

export const sidebarLogoUrl = ({ sidebar_logo_url }) => sidebar_logo_url;

export const isGlobalManagementSystem = ({ is_global_management_system }) => is_global_management_system;

export const hasClOnlyFeatures = ({ has_cl_only_features }) => has_cl_only_features;

export const systemLocale = ({ system_locale }) => system_locale;

export const latestScrollToComment = ({latest_scroll_to_comment }) => latest_scroll_to_comment;

export const passwordResetEnabled = ({ password_reset_enabled }) => password_reset_enabled;



// WEBPACK FOOTER //
// ./src/store/getters.js